module.exports = __webpack_public_path__ + "img/fondo3.0039434e.jpg";